import _ from 'lodash';

import {
    SET_SITE_CARDS,
    SET_SITE_CARDS_VISIBLE,
    SET_SITE_CARDS_FILTERS,
    FETCH_SITE_CARDS_REQUEST,
    FETCH_SITE_CARDS_SUCCESS,
    FETCH_SITE_CARDS_FAILURE,
    CREATE_SITE_CARD_REQUEST,
    CREATE_SITE_CARD_SUCCESS,
    CREATE_SITE_CARD_FAILURE,
    CREATE_SITE_CARDS_REQUEST,
    CREATE_SITE_CARDS_SUCCESS,
    CREATE_SITE_CARDS_FAILURE,
    UPDATE_SITE_CARD_REQUEST,
    UPDATE_SITE_CARD_SUCCESS,
    UPDATE_SITE_CARD_FAILURE,
    DELETE_SITE_CARD_REQUEST,
    DELETE_SITE_CARD_SUCCESS,
    DELETE_SITE_CARD_FAILURE,
    EXPORT_SITE_CARD_REQUEST,
    EXPORT_SITE_CARD_SUCCESS,
    EXPORT_SITE_CARD_FAILURE
} from './Types';

import {
    FETCH_SITE_CARD_REQUEST,
    FETCH_SITE_CARD_SUCCESS,
    FETCH_SITE_CARD_FAILURE,
    FETCH_SITE_CARD_OWNERSHIP_REQUEST,
    FETCH_SITE_CARD_OWNERSHIP_SUCCESS,
    FETCH_SITE_CARD_OWNERSHIP_FAILURE,
    FETCH_SITE_CARD_AREA_INFO_REQUEST,
    FETCH_SITE_CARD_AREA_INFO_SUCCESS,
    FETCH_SITE_CARD_AREA_INFO_FAILURE,
    FETCH_SITE_CARD_ANALYSES_REQUEST,
    FETCH_SITE_CARD_ANALYSES_SUCCESS,
    FETCH_SITE_CARD_ANALYSES_FAILURE,
    FETCH_SITE_CARD_PLANNING_APPLICATIONS_REQUEST,
    FETCH_SITE_CARD_PLANNING_APPLICATIONS_SUCCESS,
    FETCH_SITE_CARD_PLANNING_APPLICATIONS_FAILURE,
    FETCH_SITE_CARD_VALUE_INFO_REQUEST,
    FETCH_SITE_CARD_VALUE_INFO_SUCCESS,
    FETCH_SITE_CARD_VALUE_INFO_FAILURE,
    FETCH_SITE_CARD_NEARBY_REQUEST,
    FETCH_SITE_CARD_NEARBY_SUCCESS,
    FETCH_SITE_CARD_NEARBY_FAILURE,
    FETCH_SITE_CARD_TITLE_DEEDS_REQUEST,
    FETCH_SITE_CARD_TITLE_DEEDS_SUCCESS,
    FETCH_SITE_CARD_TITLE_DEEDS_FAILURE,
    CREATE_SITE_CARD_PLANNING_ALERT_REQUEST,
    CREATE_SITE_CARD_PLANNING_ALERT_SUCCESS,
    CREATE_SITE_CARD_PLANNING_ALERT_FAILURE
} from './modules/Types';

import {
    FETCH_CURRENT_PROJECT_SUCCESS,
    SET_CURRENT_PROJECT_SUCCESS
} from '../project/Types';

import { FETCH_POLYGONS_SUCCESS } from '../parcel/Types';
import { FETCH_ANALYSIS_SUCCESS, PING_ANALYSIS_SUCCESS } from '../analysis/Types';
import { ISiteCardAction, ISiteCardReducerState, SiteCard } from './siteCardTypes';
import { Criteria } from '../../utility/Types/commonTypes';

const defaultState: {
    siteCards: SiteCard[];
    isFetchingSiteCards: boolean;
    isCreatingSiteCard: boolean;
    isCreatingSiteCards: boolean;
    error: any;
    areSiteCardsVisible: boolean;
    filters: Criteria;
} = {
    siteCards: [],
    isFetchingSiteCards: false, // Used to initially wait for sitecards to load
    isCreatingSiteCard: false,
    isCreatingSiteCards: false,
    error: null,
    // Specific to main map
    areSiteCardsVisible: false, // Are site cards visible on the main map
    filters: {
        children: [],
        conjunction: 'and',
        id: 'root',
        not: false,
        type: 'group'
    }
};

export default function reducer(
    state: ISiteCardReducerState = defaultState,
    action: ISiteCardAction
) {
    switch (action.type) {
        // SET_SITE_CARDS is legacy! To maintain consistent state and prevent race conditions, sitecards are set through the project actions
        // This is still here just in case but can probably be removed
        case SET_SITE_CARDS:
            return {
                ...state,
                siteCards: [...action.siteCards],
                isFetchingSiteCards: false
            };
        case SET_SITE_CARDS_VISIBLE:
            return {
                ...state,
                areSiteCardsVisible: action.visible
            };
        case SET_SITE_CARDS_FILTERS:
            return {
                ...state,
                filters: action.filters
            };
        case FETCH_SITE_CARDS_REQUEST:
            return {
                ...state,
                isFetchingSiteCards: true,
                error: null
            };
        case FETCH_SITE_CARDS_SUCCESS:
            return {
                ...state,
                siteCards: action.siteCards,
                // uniqCombine is better but not for initial load
                // uniqCombine(state.siteCards, action.siteCards),
                isFetchingSiteCards: false,
                error: null
            };
        case FETCH_SITE_CARDS_FAILURE:
            return {
                ...state,
                isFetchingSiteCards: false,
                error: action.error
            };
        case CREATE_SITE_CARD_REQUEST:
            return {
                ...state,
                isCreatingSiteCard: true,
                error: null
            };
        case CREATE_SITE_CARD_SUCCESS:
            return {
                ...state,
                isCreatingSiteCard: false,
                siteCards: _.uniqWith(
                    [action.siteCard, ...state.siteCards],
                    siteCardComparator
                ),
                error: null
            };
        case CREATE_SITE_CARD_FAILURE:
            return {
                ...state,
                isCreatingSiteCard: false,
                error: action.error
            };
        case CREATE_SITE_CARDS_REQUEST:
            return {
                ...state,
                isCreatingSiteCards: true,
                error: null
            };
        case CREATE_SITE_CARDS_SUCCESS:
            return {
                ...state,
                isCreatingSiteCards: false,
                siteCards: _.uniqWith(
                    [...action.siteCards, ...state.siteCards],
                    siteCardComparator
                ),
                error: null
            };
        case CREATE_SITE_CARDS_FAILURE:
            return {
                ...state,
                isCreatingSiteCards: false,
                error: action.error
            };

        // Fetch requests for dashboard
        case FETCH_SITE_CARD_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            if (siteCardIdx === -1) {
                newSiteCards.push({
                    id: action.id,
                    isFetchingSiteCard: true,
                    error: null
                });
            } else {
                newSiteCards[siteCardIdx] = {
                    ...newSiteCards[siteCardIdx],
                    id: action.id,
                    isFetchingSiteCard: true,
                    error: null
                };
            }
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                ...action.siteCard,
                isFetchingSiteCard: false,
                notFound: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingSiteCard: false,
                notFound: true,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_OWNERSHIP_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingOwnership: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_OWNERSHIP_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                ownership: action.ownership,
                isFetchingOwnership: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_OWNERSHIP_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingOwnership: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_AREA_INFO_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingAreaInfo: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_AREA_INFO_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                areaInfo: action.areaInfo,
                isFetchingAreaInfo: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_AREA_INFO_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingAreaInfo: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_ANALYSES_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingAnalysis: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_ANALYSES_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                featureAnalyses: action.featureAnalyses,
                isFetchingAnalysis: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_ANALYSES_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingAnalysis: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_PLANNING_APPLICATIONS_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingPlanningApplications: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_PLANNING_APPLICATIONS_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                planningApplications: action.planningApplications,
                isFetchingPlanningApplications: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_PLANNING_APPLICATIONS_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingPlanningApplications: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_VALUE_INFO_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingValueInfo: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_VALUE_INFO_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                valueInfo: action.valueInfo,
                isFetchingValueInfo: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_VALUE_INFO_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingValueInfo: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_NEARBY_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingNearby: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_NEARBY_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                nearby: action.nearby,
                isFetchingNearby: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_NEARBY_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingNearby: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_TITLE_DEEDS_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isFetchingTitleDeeds: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_TITLE_DEEDS_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                titleDeeds: action.titleDeeds,
                isFetchingTitleDeeds: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case FETCH_SITE_CARD_TITLE_DEEDS_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isFetchingTitleDeeds: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        // General requests
        case UPDATE_SITE_CARD_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isUpdatingSiteCard: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case UPDATE_SITE_CARD_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                ...action.siteCard,
                isUpdatingSiteCard: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case UPDATE_SITE_CARD_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isUpdatingSiteCard: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case DELETE_SITE_CARD_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.id,
                isDeletingSiteCard: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case DELETE_SITE_CARD_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards.splice(siteCardIdx, 1);
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case DELETE_SITE_CARD_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(el => el.id === action.id);
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isDeletingSiteCard: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }

        case CREATE_SITE_CARD_PLANNING_ALERT_REQUEST: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(
                el => el.id === action.siteCardId
            );
            newSiteCards[siteCardIdx] = {
                ...(siteCardIdx === -1 ? {} : newSiteCards[siteCardIdx]),
                id: action.siteCardId,
                isCreatingPlanningAlert: true,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case CREATE_SITE_CARD_PLANNING_ALERT_SUCCESS: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(
                el => el.id === action.siteCardId
            );
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                planningAlertId: action.planningAlert.id,
                isCreatingPlanningAlert: false,
                error: null
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }
        case CREATE_SITE_CARD_PLANNING_ALERT_FAILURE: {
            const newSiteCards = [...state.siteCards];
            const siteCardIdx = state.siteCards.findIndex(
                el => el.id === action.siteCardId
            );
            newSiteCards[siteCardIdx] = {
                ...newSiteCards[siteCardIdx],
                isCreatingPlanningAlert: false,
                error: action.error
            };
            return {
                ...state,
                siteCards: newSiteCards
            };
        }

        // When the project is changed then clear the searches
        case FETCH_CURRENT_PROJECT_SUCCESS:
        case SET_CURRENT_PROJECT_SUCCESS: {
            return {
                ...state,
                siteCards: action.includeSiteCards ? state.siteCards : [],
                filters: {
                    children: [],
                    conjunction: 'and',
                    id: 'root',
                    not: false,
                    type: 'group'
                }
            };
        }
        // To maintain a single source of truth on the frontend, all sitecards are stored in one place
        // So whenever another action/reducer needs to load site cards, we ensure they are added here
        case FETCH_POLYGONS_SUCCESS: {
            return {
                ...state,
                siteCards: uniqCombine(state.siteCards, action.bundle.siteCards)
            };
        }
        case PING_ANALYSIS_SUCCESS:
        case FETCH_ANALYSIS_SUCCESS: {
            const siteCards = [];
            for (const fa of action.analysis.featureAnalyses) {
                if (fa.siteCard) {
                    siteCards.push(fa.siteCard);
                }
            }
            return {
                ...state,
                siteCards: uniqCombine(state.siteCards, siteCards)
            };
        }
        case EXPORT_SITE_CARD_REQUEST:
            return {
                ...state,
                isExporting: true,
                error: null
            };
        case EXPORT_SITE_CARD_SUCCESS:
            return {
                ...state,
                isExporting: false,
                error: null
            };
        case EXPORT_SITE_CARD_FAILURE:
            return {
                ...state,
                isExporting: false,
                error: action.error
            };
        default:
            return state;
    }
}

function siteCardComparator(object: { id: string }, other: { id: string }) {
    return object.id === other.id;
}

// TODO replace some above methods with this, with additional parameters to combine in?
// Add unique to the array, combine/replace existing
function uniqCombine(srcSiteCards: SiteCard[], tgtSiteCards: SiteCard[]) {
    const newSiteCards = [...srcSiteCards];
    for (const tgtSiteCard of tgtSiteCards) {
        const idx = newSiteCards.findIndex(sc => sc.id === tgtSiteCard.id);
        if (idx === -1) {
            newSiteCards.push(tgtSiteCard);
        } else {
            newSiteCards[idx] = {
                ...newSiteCards[idx],
                ...tgtSiteCard
            };
        }
    }
    return newSiteCards;
}
